/* src/app/components/error-promcode-dialog/error-promcode-dialog.component.css */
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
ion-icon {
  width: 70px;
  height: 70px;
  margin-bottom: 15px;
}
ion-button {
  min-height: 40px;
}
h3,
p {
  margin-bottom: 15px;
  text-align: center;
  color: var(--ion-color-secondary);
}
#barcode {
  width: 100%;
  height: 100px;
}
.without_promo {
  margin-top: 10px;
  --background: var(--ion-color-danger);
  color: white;
  text-transform: inherit;
}
/*# sourceMappingURL=error-promcode-dialog.component.css.map */
